import React, { useState, useEffect } from 'react';
import axios from 'axios';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#6c757d',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
    fontFamily: '"Noto Sans KR", sans-serif'
  },
  modal: {
    width: '100%',
    maxWidth: '420px',
    background: '#fff',
    borderRadius: '4px',
    boxShadow: '0 0.5rem 1rem rgba(0,0,0,.15)',
    overflow: 'hidden'
  },
  header: {
    padding: '3rem 3rem 1.5rem 3rem'
  },
  title: {
    margin: 0,
    fontWeight: 700,
    fontSize: '2rem'
  },
  body: {
    padding: '0 3rem 3rem 3rem'
  },
  alert: {
    marginBottom: '1rem',
    padding: '0.75rem 1rem',
    borderRadius: '0.375rem',
    background: '#f8d7da',
    color: '#842029',
    border: '1px solid #f5c2c7'
  },
  inputWrap: {
    marginBottom: '1rem'
  },
  label: {
    display: 'block',
    marginBottom: '0.375rem',
    color: '#495057',
    fontSize: '0.95rem'
  },
  input: {
    width: '100%',
    height: '58px',
    padding: '1rem 0.75rem',
    borderRadius: '0.5rem',
    border: '1px solid #ced4da',
    fontSize: '1rem',
    boxSizing: 'border-box'
  },
  button: {
    width: '100%',
    marginBottom: '0.5rem',
    height: '48px',
    border: 'none',
    borderRadius: '0.25rem',
    background: '#0d6efd',
    color: '#fff',
    fontSize: '1.125rem',
    cursor: 'pointer'
  },
  footer: {
    marginTop: '3rem',
    marginBottom: '1rem',
    color: '#6c757d',
    fontSize: '0.875rem'
  }
};

export default function KitchenManage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = TrueWorkaround();
    axios.get('/api/kitchen/auth/me', { withCredentials: true })
      .then((res) => {
        if (!mounted) return;
        if (res.data && res.data.is_seller === true) {
          window.location.href = '/kitchen/orders';
        }
      })
      .catch(() => {})
    return () => { mounted = false; };
  }, []);

  function TrueWorkaround() {
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const form = new URLSearchParams();
    form.append('username', username);
    form.append('password', password);

    try {
      const res = await axios.post('/api/kitchen/manage', form, {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });

      const data = res.data || {};
      if (!data.ok) {
        setError(data.msg || '아이디 또는 비밀번호가 올바르지 않습니다.');
        return;
      }

      window.location.href = data.redirect || '/kitchen/orders';
    } catch (err) {
      const msg =
        err?.response?.data?.msg ||
        '아이디 또는 비밀번호가 올바르지 않습니다.';
      setError(msg);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h1 style={styles.title}>주방 로그인</h1>
        </div>

        <div style={styles.body}>
          <form onSubmit={handleSubmit}>
            {error ? <div style={styles.alert}>{error}</div> : null}

            <div style={styles.inputWrap}>
              <label style={styles.label} htmlFor="floatingInput">아이디</label>
              <input
                type="text"
                name="username"
                id="floatingInput"
                placeholder="Id"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={styles.input}
              />
            </div>

            <div style={styles.inputWrap}>
              <label style={styles.label} htmlFor="floatingPassword">패스워드</label>
              <input
                type="password"
                name="password"
                id="floatingPassword"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
              />
            </div>

            <button style={styles.button} type="submit">
              로그인
            </button>

            <div style={styles.footer}>&copy; 2025</div>
          </form>
        </div>
      </div>
    </div>
  );
}